require('slick-carousel');

function slickInit(item, nav, size) {

    let sliderNavigate = $(nav);
    let maxWidth = size;
    let slickVar = {
            // lazyLoad: 'ondemand',
            dots: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 2,
            mobileFirst: true,
            // variableWidth: true,
            arrows: true,
            speed: 400,
            autoplay: true,
            autoplaySpeed: 7000,
            appendArrows: sliderNavigate,
            prevArrow: '<div class="partners-slider__nav partners-slider__prev"><svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M21.2214 0.333C20.7774 -0.111 20.0784 -0.111 19.6344 0.333C19.2054 0.762 19.2054 1.476 19.6344 1.904L27.6814 9.951H1.12737C0.508367 9.951 0.000368118 10.443 0.000368118 11.062C0.000368118 11.681 0.508367 12.189 1.12737 12.189H27.6814L19.6344 20.221C19.2054 20.665 19.2054 21.38 19.6344 21.808C20.0784 22.252 20.7774 22.252 21.2214 21.808L31.1734 11.856C31.6024 11.427 31.6024 10.713 31.1734 10.285L21.2214 0.333Z" fill="#F0A929"/>\n' +
                '</svg></div>',
            nextArrow: '<div class="partners-slider__nav partners-slider__next"><svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M21.2214 0.333C20.7774 -0.111 20.0784 -0.111 19.6344 0.333C19.2054 0.762 19.2054 1.476 19.6344 1.904L27.6814 9.951H1.12737C0.508367 9.951 0.000368118 10.443 0.000368118 11.062C0.000368118 11.681 0.508367 12.189 1.12737 12.189H27.6814L19.6344 20.221C19.2054 20.665 19.2054 21.38 19.6344 21.808C20.0784 22.252 20.7774 22.252 21.2214 21.808L31.1734 11.856C31.6024 11.427 31.6024 10.713 31.1734 10.285L21.2214 0.333Z" fill="#F0A929"/>\n' +
                '</svg></div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 690,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 300,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
            ]
        },
        runSlick = function() {
            $(item).not('.slick-initialized').slick(slickVar);
        };

    runSlick();

}
slickInit('.partners-slider__slider', '.partners-slider__nav', 1025);
